class LogInOutController {

    constructor($scope, storeService, loginoutService) {
        this.storeService = storeService;
        this.loginoutService = loginoutService;
        this.$scope = $scope;
    }

    login () {
        return this.loginoutService.login().then(response => { this.maybeRequestAvailability({ response: response }); });
    }

    logout () {
        return this.loginoutService.logout().then(response => {
            this.guests = [];
            this.maybeRequestAvailability({ response: response }).then(() => {
                this.$scope.$apply();
            });
        });
    }

    isLoggedIn () {
        return this.loginoutService.isLoggedIn();
    }

    isLoginAllowed () {
        return this.loginoutService.isAllowed();
    }
}

LogInOutController.$inject = ['$scope', 'storeService', 'loginoutService'];

export default LogInOutController;



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/widget/controllers/logInOut.controller.js